<template>
  <div class="contract-detail">
    <el-collapse v-model="activeCollapses" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基础信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseInfoData"
            :columns="baseColumns"
            :isQueryPanel="false"
            labelWidth="150px"
            @changeMethod="changeValueHandler"
            :rules="tableRules"
          >
          </SiruiSearch>
          <!-- <formItem
            ref="baseInfoFormRef"
            :params="baseInfoData"
            :columns="baseColumns"
            :rules="tableRules"
            @changeValueHandler="changeValueHandler"
            @departmentChanged="departmentChangeHandler"
            labelWidth="150px"
          >
          </formItem> -->
          <div class="service-group-buttons">
            <el-form
              :model="baseInfoData"
              :rules="tableRules"
              ref="productServiceRef"
              :disabled="productServiceDisabled"
            >
              <el-form-item label="产品类型" prop="productType">
                <el-checkbox-group v-model="checkedProductTypes" @change="handleProductTypeChange">
                  <el-checkbox v-for="item in productTypeList" :label="item.label" :key="item.value"
                    >{{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="服务类型" prop="serviceTypeCode">
                <el-checkbox-group v-model="checkedServiceTypes" @change="handleServiceTypeChange">
                  <el-checkbox
                    v-for="item in serviceTypeDictList"
                    :label="item.label"
                    :key="item.value"
                    :disabled="item.disabled"
                    >{{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            结算信息
          </div>
        </template>
        <div class="collapse-content">
          <div class="reconciliation-group-buttons">
            <el-form
              :model="baseInfoData"
              ref="reconciliationRef"
              :rules="tableRules"
              label-position="right"
              label-width="90px"
              :disabled="settlementDisabled"
            >
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="付款方式" prop="payType">
                    <el-select
                      v-model="checkedPayTypes"
                      size="medium"
                      @change="handlePayTypeChange"
                      multiple
                    >
                      <el-option
                        v-for="item in payMethodList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="结算备注" prop="settlementRemarks">
                    <el-input
                      v-model="baseInfoData.settlementRemarks"
                      placeholder="请输入"
                      size="medium"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-form-item label="付款方式" prop="payType">
                <!== payment_method ==>
                <!== <el-checkbox-group v-model="checkedPayTypes" @change="handlePayTypeChange">
                  <el-checkbox v-for="item in payTypeList" :label="item.label" :key="item.value"
                    >{{ item.label }}
                  </el-checkbox>
                </el-checkbox-group> ==>
              </el-form-item> -->
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="对账规则" prop="reconciliateRule">
                    <el-select
                      v-model="baseInfoData.reconciliateRule"
                      size="medium"
                      @change="handleReconciliateRuleChange"
                    >
                      <el-option
                        v-for="item in reconciliationRulesList"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="对账周期" prop="reconciliatePeriod">
                    <el-select
                      v-model="baseInfoData.reconciliatePeriod"
                      size="medium"
                      :disabled="baseInfoData.reconciliateRule != '固定日期结算'"
                    >
                      <el-option label="半月结" value="0"></el-option>
                      <el-option label="每月结" value="1"></el-option>
                      <el-option label="二月结" value="2"></el-option>
                      <el-option label="三月结" value="3"></el-option>
                      <el-option label="其他" value="5"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="concatReconcileLabel()"
                    prop="reconciliateDate"
                    :label-width="getReconcilLabel() == '' ? '90px' : '160px'"
                  >
                    <el-row>
                      <el-col :span="10">
                        <input-number-ad
                          v-model="baseInfoData.reconciliateDate"
                          clearable
                          placeholder=""
                          :min="1"
                          :max="999"
                          :controls="false"
                          :precision="0"
                        >
                        </input-number-ad
                      ></el-col>
                      <el-col :span="14"> {{ getReconcilLabel(false) }}</el-col>
                    </el-row>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="8" v-if="isCustomerContract">
                  <el-form-item
                    label="逾期账期    开票后"
                    prop="overdueAccountPeriod"
                    label-width="150px"
                  >
                    <el-row>
                      <el-col :span="10">
                        <input-number-ad
                          v-model="baseInfoData.overdueAccountPeriod"
                          placeholder=""
                          clearable
                          :min="-999"
                          :max="999"
                          :controls="false"
                          :precision="0"
                          @input="(value) => replaceValue(value)"
                        >
                        </input-number-ad>
                      </el-col>
                      <el-col :span="14">
                        <span>日</span>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-col></el-row
              >
            </el-form>
          </div>
        </div>
      </el-collapse-item>
      <!-- <el-collapse-item name="3" v-if="!isCustomerContract">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            付款账户信息
          </div>
        </template>
        <div class="collapse-content">
          <el-form
            :model="baseInfoData"
            :rules="tableRules"
            label-width="105px"
            ref="accountInfoRef"
          >
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="账户名称" prop="accountName">
                  <el-input
                    v-model="baseInfoData.accountName"
                    size="medium"
                    :disabled="accountInfoDisabled"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="开户银行" prop="accountBank">
                  <!== <el-input
                    v-model="baseInfoData.accountBank"
                    size="medium"
                    :disabled="accountInfoDisabled"
                  ></el-input> ==>
                  <el-select
                    v-model="baseInfoData.accountBankNo"
                    size="medium"
                    :disabled="accountInfoDisabled"
                    placeholder="请选择银行账号"
                    @change="handleBankChange"
                  >
                    <el-option
                      v-for="(item, index) in curBankList"
                      :key="index"
                      :label="item.bankName + '-' + item.bankAccount"
                      :value="item.bankAccount"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="银行账号" prop="accountBankNo">
                  <el-input v-model="baseInfoData.accountBankNo" size="medium" :disabled="true">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-collapse-item> -->
      <el-collapse-item name="4" v-if="isCustomerContract">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            开票信息
          </div>
        </template>
        <div class="collapse-content">
          <InvoiceInfoTable
            ref="invoiceInfoRef"
            :billingDisabledList="billingDisabledList"
            :tableDataList="baseInfoData.invoiceList"
            @change="(data) => (baseInfoData.invoiceList = data)"
          />
          <!-- <el-form :model="baseInfoData" :rules="tableRules" label-width="100px" ref="billingRef">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="纳税人名称" prop="taxpayerName">
                  <el-input
                    v-model="baseInfoData.taxpayerName"
                    :disabled="billingDisabledList.includes('taxpayerName')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="纳税人识别号" prop="taxpayerIdentifyCode">
                  <el-input
                    v-model="baseInfoData.taxpayerIdentifyCode"
                    :disabled="billingDisabledList.includes('taxpayerIdentifyCode')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="开户银行" prop="accountBank">
                  <el-input
                    v-model="baseInfoData.accountBank"
                    size="medium"
                    :disabled="billingDisabledList.includes('accountBank')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="银行账号" prop="accountBankNo">
                  <el-input
                    v-model="baseInfoData.accountBankNo"
                    size="medium"
                    :disabled="billingDisabledList.includes('accountBankNo')"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="地址电话" prop="addressPhone">
                  <el-input
                    v-model="baseInfoData.addressPhone"
                    size="medium"
                    :disabled="billingDisabledList.includes('addressPhone')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="增值税发票类型" prop="vatInvoiceType" label-width="120px">
                  <el-select
                    v-model="baseInfoData.vatInvoiceType"
                    size="medium"
                    :disabled="billingDisabledList.includes('vatInvoiceType')"
                  >
                    <el-option label="增值税专用发票" value="增值税专用发票"></el-option>
                    <el-option label="增值税普通发票" value="增值税普通发票"></el-option
                  ></el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form> -->
        </div>
      </el-collapse-item>
      <el-tabs class="editCooperationTabs" type="border-card" v-model="activeTabName">
        <el-tab-pane label="运输货物及线路" name="freightAndRouteDetailTab">
          <FreightDetailChart
            :tableDataList="cargos"
            @handleChartChange="handleChartChange"
            :disabled="freightAndRouteDisabled"
          >
          </FreightDetailChart>
          <RouteDetailChart
            :tableDataList="routes"
            :contractCode="baseInfoData.contractCode"
            @handleChartChange="handleChartChange"
            :disabled="freightAndRouteDisabled"
          ></RouteDetailChart>
        </el-tab-pane>
        <el-tab-pane label="服务计费规则" name="serviceFeeTab">
          <ServiceFeeChart
            :tableDataList="serviceChargeRules"
            :routes="routes"
            :cargos="cargos"
            :contractCode="baseInfoData.contractCode"
            otherTitle="服务计费规则"
            :selectedServices="checkedServiceTypes"
            :selectedProducts="checkedProductTypes"
            :disabled="serviceFeeDisabled"
            @handleChartChange="handleChartChange"
          >
          </ServiceFeeChart>
        </el-tab-pane>
        <el-tab-pane
          v-if="(pageMode != 0 && origin != 'record') || origin == 'supplement'"
          label="关联明细"
          name="associatedDetailTab"
        >
          <AssociatedContractDetailChart
            :chartType="isCustomerContract ? 'customer' : 'supplier'"
            :contractType="baseInfoData.contractType"
            :contractStatus="baseInfoData.contractStatus"
            @createSupplement="createSupplement"
            @relateComplete="relateComplete"
          ></AssociatedContractDetailChart>
        </el-tab-pane>
        <el-tab-pane
          v-if="pageMode != 0 && origin != 'record' && baseInfoData.contractType == '0'"
          label="变更记录"
          name="changeRecord"
        >
          <ChangeRecord
            :contractCode="baseInfoData.contractCode"
            :isCustomerContract="isCustomerContract"
          />
        </el-tab-pane>
        <!-- <el-tab-pane v-if="pageMode != 0" label="审批记录" name="auditionRecordTab">
          <AuditionRecordChart :code="this.baseInfoData.contractCode"></AuditionRecordChart
        ></el-tab-pane> -->
      </el-tabs>
      <!--附件-->
      <el-collapse-item name="5">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            v-if="statusName != '已生效' || origin == 'record'"
            ref="fileTableRef"
            :attachments="attachments"
            :isShowDownBtn="uploadDisabled"
            :isDisabledDelete="deleteFileDisabled"
          />
          <!-- 已生效状态下上传附件 -->
          <EffectiveFileTable
            v-else
            ref="fileTableRef"
            :attachments="attachments"
            :contractCode="baseInfoData.contractCode"
            :isShowDownBtn="uploadDisabled"
            :isDisabledupload="deleteFileDisabledSX"
            @reloadPage="reloadPage1"
          ></EffectiveFileTable>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮 fixme需要判断立项状态显示-->
    <footer v-if="origin != 'record'" class="bottomButtons">
      <DetailFooterButtons
        @btnHandler="btnHandler"
        :pageMode="pageMode"
        :contractStatus="baseInfoData.contractStatus"
        :contractType="baseInfoData.contractType"
      />
    </footer>
    <CommonTextDialog ref="textDialog"></CommonTextDialog>
  </div>
</template>

<script>
  // import formItem from '../../common/components/form-item.vue';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import { baseRules } from './columns/tableRules.js';
  import FreightDetailChart from '@/pages/intermodality/common/charts/freightDetailChart/index.vue';
  import RouteDetailChart from '@/pages/intermodality/common/charts/routeDetailChart/index.vue';
  import ServiceFeeChart from '@/pages/intermodality/common/charts/serviceFeeChart/index.vue';
  import AssociatedContractDetailChart from '@/pages/intermodality/contract/detail/components/associatedDetailChart/index.vue';
  import ChangeRecord from './components/changeRecord/index.vue';
  // import AuditionRecordChart from '@/pages/intermodality/common/charts/auditionRecordChart/index.vue';
  import DetailFooterButtons from './components/DetailFooterButtons.vue';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  import ContractServiceMixin from '@/pages/intermodality/contract/detail/mixins/ContractServiceMixin';
  import ContractFormStatusMixin from '@/pages/intermodality/contract/detail/mixins/ContractFormStatusMixin';
  import CommonTextDialog from '@/pages/intermodality/common/components/dialogs/CommonTextDialog';
  import FileTable from '@/components/business/FileTable/index.vue';
  import EffectiveFileTable from './components/effectiveFileTable/EffectiveFileTable.vue';
  import InvoiceInfoTable from './components/invoiceInfoTable/index.vue';
  // import { values } from 'xe-utils/methods/index.js';
  // import EffectiveFileTable from './components/effectiveFileTable/EffectiveFileTable.vue';
  export default {
    name: 'customerContractCreation',
    mixins: [IntermodalityCommonMixin, ContractServiceMixin, ContractFormStatusMixin],
    components: {
      FreightDetailChart,
      FileTable,
      RouteDetailChart,
      ServiceFeeChart,
      // AuditionRecordChart,
      AssociatedContractDetailChart,
      // formItem,
      DetailFooterButtons,
      CommonTextDialog,
      inputNumberAd,
      EffectiveFileTable,
      ChangeRecord,
      InvoiceInfoTable,
    },
    data() {
      return {
        //0代表创建，1代表详情页查看状态，2代表详情页编辑状态
        activeTabName: 'freightAndRouteDetailTab',
        activeCollapses: ['1', '2', '3', '4', '5'],
        pageMode: 0,
        origin: '',
        isCustomerContract: true,
        statusName: '',
      };
    },
    computed: {
      tableRules() {
        return baseRules(this);
      },
    },
    methods: {
      replaceValue(val) {
        if (val) {
          var len1 = val.substr(0, 1);
          if (val.length > 1 && len1 == 0) {
            val = val.substr(0, 1);
          } else {
            val = val.replace(/^\.+|[^\d]+/g, '');
          }
          this.baseInfoData.overdueAccountPeriod = val;
        }
      },
      concatReconcileLabel() {
        let label = '对账日期';
        if (this.getReconcilLabel() != '') {
          label = label + '    ';
          label = label + this.getReconcilLabel();
        }
        return label;
      },
      getReconcilLabel(isPrefix = true) {
        if (!this.baseInfoData.reconciliateRule) {
          if (isPrefix) {
            return '';
          } else {
            return '日';
          }
        } else {
          if (this.baseInfoData.reconciliateRule == '固定日期结算') {
            if (isPrefix) {
              return '每月';
            } else {
              return '日对账';
            }
          } else {
            if (isPrefix) {
              return '运输完成后';
            } else {
              return '日对账';
            }
          }
        }
      },
      clearValidate() {
        this.$refs.productServiceRef.clearValidate();
        this.$refs.reconciliationRef.clearValidate();
      },
      handleSwitchEditMode() {
        this.pageMode = this.pageMode == 1 ? 2 : 1;
        this.assignBaseColumnsStatus(this.baseInfoData);
        this.getProcessedBaseColumns(
          this.getStatusName('contract', this.baseInfoData.contractStatus),
          this.$route.query?.origin
        );
      },
      createSupplement() {
        let contractType = this.baseInfoData.contractType;
        if (contractType != '0') {
          this.$message({
            type: 'error',
            message:
              '新增失败！您选择的合同已为结算条款，不可再新增结算条款，请选择结算条款所属的常规合同进行结算条款维护',
          });
          return;
        }
        let params = {
          pageMode: 0,
          origin: 'supplement',
          contractCode: this.baseInfoData.contractCode,
        };
        this.toDetailPage(params);
      },
      async btnHandler(name, params) {
        let contractStatus = this.baseInfoData?.contractStatus;
        let contractCode = this.baseInfoData?.contractCode;
        let contractType = this.baseInfoData?.contractType;
        let statusName = this.getStatusName('contract', contractStatus);
        // this.statusName = this.getStatusName('contract', this.baseInfoData?.contractStatus);
        switch (name) {
          case 'revise':
            if ((await this.checkSupplementUnderApproval(contractCode)) == false) {
              this.$message({
                type: 'error',
                message: '该合同下结算条款未全部生效，无法补充协议，请检查！',
              });
              return;
            }
            this.handleSwitchEditMode();
            break;
          case 'save':
            //0保存1提交
            this.save(this.baseInfoData, this.cargos, this.routes, this.serviceChargeRules, params);
            break;
          case 'edit':
            this.handleSwitchEditMode();
            break;
          case 'view':
            this.handleSwitchEditMode();
            break;
          // case 'cancel':
          //   if (this.isCustomerContract) {
          //     this.$router.push({ path: '/intermodality/customerContract' });
          //   } else {
          //     this.$router.push({ path: '/intermodality/supplierContract' });
          //   }
          //   break;
          case 'delete':
            this.$confirmAction('删除合同确认', '是否确定要删除此合同？', '确认', '取消')
              .then(async () => {
                this.loading.startLoading();
                var res = await this.deleteContract();
                this.loading.endLoading();
                if (res.data.code == 0) {
                  this.$message.success(res.data.msg);
                  let path = `/intermodality/${
                    this.isCustomerContract ? 'customerContract' : 'supplierContract'
                  }`;
                  this.$router.push({ path: path });
                } else {
                  this.$message.error(res.data.msg);
                }
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: 'info',
                  message: '已取消',
                });
              });

            break;
          case 'activate':
            if (statusName != '已停用') {
              this.$message({
                type: 'error',
                message: '请选择一条已停用的数据',
              });
              return;
            }
            var title = '';
            if (contractType != '0') {
              title = '结算条款';
            } else {
              if (this.isCustomerContract) {
                title = '客户合同';
              } else {
                title = '供方合同';
              }
            }
            this.$confirmAction(`${title}启用确认`, `是否确定要启用此${title}?`, '确认启用', '取消')
              .then(async () => {
                this.handleUpdateStatus(true, contractCode, contractType);
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: 'info',
                  message: '已取消',
                });
              });
            break;
          case 'deactivate':
            if (statusName != '已生效') {
              this.$message({
                type: 'error',
                message: '请选择一条已生效的数据',
              });
              return;
            }
            if ((await this.checkSupplementUnderApproval(contractCode)) == false) {
              this.$message({
                type: 'error',
                message: '该合同的结算条款状态为审批中，无法停用，请检查！',
              });
              return;
            }
            var title2 = '';
            var message =
              '合同停用后，对应的结算条款将同步停用，且无法再创建订单。是否确定要停用此合同？';
            if (contractType != '0') {
              title2 = '结算条款';
              message = '是否确定要停用此结算条款?';
            } else {
              if (this.isCustomerContract) {
                title2 = '客户合同';
              } else {
                title2 = '供方合同';
              }
            }
            this.$confirmAction(`${title2}停用确认`, message, '确认停用', '取消')
              .then(async () => {
                this.handleUpdateStatus(false, contractCode, contractType);
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: 'info',
                  message: '已取消',
                });
              });
            break;
          case 'editContractNo':
            this.savePaperContractNo();
            break;
          default:
            break;
        }
      },

      async init() {
        await this.getDeptList();
        await this.getCommonDicts();
        await this.initDetail();
      },
      async reloadPage1() {
        await this.initDetail();
        console.log('reloadPage');
      },
    },
    mounted() {
      if (this.$route.query?.pageMode) {
        this.pageMode = Number(this.$route.query?.pageMode);
      }
      if (this.$route.query?.origin) {
        this.origin = this.$route.query?.origin;
      }
      let name = this.$route.name;
      this.isCustomerContract =
        name == 'customerContractDetail' ||
        name == 'customerContractCreation' ||
        name == 'customerContractHistoryDetail' ||
        name == 'customerContractCopy';

      console.log('isCustomerContract', this.isCustomerContract);
      this.init();
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 20px 0px;
    box-sizing: border-box;
  }

  .footer-bottom-list {
    justify-content: center;
    display: flex;
    padding-top: 20px;
  }

  .bottomButtons {
    padding-top: 20px;
    text-align: center;
  }
</style>
